import Amount from './Amount';

export default class AccountingOverview {
    public totalPurchaseAmount: Amount;
	public totalNumberOfItems: number;
	public totalStockValueAmount: Amount;

	public currentStockPurchaseAmount: Amount;
	public numberOfItemsInStock: number;
	public currentStockValueAmount: Amount;

	public soldStockPurchaseAmount: Amount;
	public numberOfItemsSold: number;
	public soldStockValueAmount: Amount;
	public soldStockDiscountAmount: Amount;
}
